export function formataMoeda (v, {disableZero=true, removeCents=true}={}) {
  if (v == "-") return v
  let v_ = parseFloat(v);
  if (v_ == 0 && disableZero) return "-"
  let __ = v_.toLocaleString("pt-BR", { style: "currency", currency:"BRL" } )
  if (removeCents) {
    return __.substr(0,__.length - 3);  // remove os centavos...
  } else {
    return __;
  }
}
